import { render, staticRenderFns } from "./TagSearchForm.vue?vue&type=template&id=c23bae5c"
import script from "./TagSearchForm.vue?vue&type=script&lang=js"
export * from "./TagSearchForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports